'use client';
import React from 'react';
import { IRepository, IResourceVersion } from '@/types';
import useRepositoryFolder from '@/hooks/useRepositoryFolder';

import { Row, Card } from '@/ui/primatives';
import * as Icon from '@/ui/Icon';

import Loader from './Loader';

import RepositoryFolderView from '@/components/Repository/RepositoryFolderView';

const ClientFolderContents: React.FC<{
  repository: IRepository;
  resource: IResourceVersion;
  page?: number;
  limit?: number;
  authToken?: string;
  children?: React.ReactNode;
}> = ({ repository, resource, page = 1, limit = 10, authToken, children }) => {
  const { entries, pagination, error, isLoading } = useRepositoryFolder({ repository, resource, page });
  const isEmptyFolder = !isLoading && !error && !((entries || []).length > 0);

  if (isLoading) {
    return <Loader rows={limit} />;
  }

  if (error) {
    return (
      <Card error={!!error}>
        <Row gap={10} alignItems="center">
          <Icon.ExclamationCircle width={16} />
          <h6>We were unable to load this folder</h6>
        </Row>
        <div>{error.title}</div>
      </Card>
    );
  }

  if (isEmptyFolder) {
    return (
      <Card style={{ textAlign: 'center' }}>
        <div>Folder is empty in this version</div>
      </Card>
    );
  }

  return (
    <RepositoryFolderView repository={repository} entries={entries} pagination={pagination} resource={resource}>
      {children}
    </RepositoryFolderView>
  );
};

export default ClientFolderContents;
